export default __webpack_public_path__ + "static/media/line-dark.736770d9.svg";